// material
import { styled } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, SvgIcon, Box, TextField } from '@mui/material';
// component
import Iconify from '../Iconify';
import { Search as SearchIcon } from '../../icons/search';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  // height: 96,
  display: 'flex',
  flexWrap: 'nowrap',
  // justifyContent: 'space-between',
  padding: theme.spacing(3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: "100%",
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  // '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  // '&.Mui-focused': { width: 320, boxShadow: 3 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

export default function ItemListToolbar({ bulkActions, selectedItemIds, emptySelection, filterName, onFilterName }) {
  const numSelected = selectedItemIds.length
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography sx={{whiteSpace: "nowrap"}} component="div" variant="subtitle1">
          {numSelected} selectionnées
        </Typography>
      ) : null }

      {numSelected > 0 ? (
        <>
          <Box sx={{pr: 4}}>
          </Box>
          { 
            bulkActions ? bulkActions
            .filter(action => action.isVisible ? action.isVisible(selectedItemIds) : true)
            .map((action, idx) => (
              <Tooltip key={idx} title={action.title}>
                <IconButton onClick={() => {
                  action.handler(selectedItemIds);
                  emptySelection();
                }}>
                  <Iconify icon={action.iconName}/>
                </IconButton>
              </Tooltip>
            )) : null
          }
          {/* <Tooltip title="Annuler">
            <IconButton>
              <Iconify icon="eva:trash-2-outline" />
            </IconButton>
          </Tooltip>          
          <Tooltip title="Marquer disponible">
            <IconButton>
              <Iconify icon="eva:checkmark-circle-outline" />
            </IconButton>
          </Tooltip> */}
          <Box sx={{pr: 4}}>
          </Box>
        </>
      ) : null }

      <TextField
        // sx={numSelected > 0 ? { width: "50%" } : { width: "100%" }}
        sx={{width: "100%" }}
        value={filterName}
        onChange={onFilterName}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SvgIcon
                color="action"
                fontSize="small"
              >
                <SearchIcon />
              </SvgIcon>
            </InputAdornment>
          )
        }}
        placeholder="Chercher..."
        variant="outlined"
      />
    </RootStyle>
  );
}